var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"svg-container"},[_c('svg',{staticClass:"icon mas-icon",class:['mas-' + _vm.icon, _vm.iconClass]},[_c('use',{attrs:{"xlink:href":'#' + _vm.icon,"xmlns:xlink":"http://www.w3.org/1999/xlink"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }